<footer id="footer" class="py-4">
  <div class="container">
    <div class="row">

      <!-- Enlaces principales -->
      <div class="col-12 col-md-4 mb-4 mb-md-0">
        <h5>Enlaces Rápidos</h5>
        <ul class="list-unstyled quick-links">
          <li><a href="/" aria-label="Inicio"><i class="fa fa-angle-double-right"></i> Inicio</a></li>
          <li><a [routerLink]="['/pregunta']" routerLinkActive="router-link-active" aria-label="Preguntas frecuentes"><i
                class="fa fa-angle-double-right"></i>
              Preguntas
              Frecuentes</a>
          </li>
          <li><a [routerLink]="['/quien']" aria-label="Contáctanos"><i class="fa fa-angle-double-right"></i>
              Quienes Somos</a>
          </li>
        </ul>
      </div>

      <!-- Información de contacto -->
      <div class="col-12 col-md-4 mb-4 mb-md-0">
        <h5>Contacto</h5>
        <p><strong>Dirección:</strong> {{conf?.dir}}</p>
        <p><strong>Email:</strong> <a href="mailto:{{conf?.emi}}" aria-label="Enviar email"> {{conf?.emi}}</a></p>
        <p><strong>Teléfono:</strong> <a href="tel:{{conf?.tel}}" aria-label="Llamar por teléfono"> {{conf?.tel}}</a>
        </p>
      </div>

      <!-- Redes sociales -->
      <div class="col-12 col-md-4 text-center text-md-start">
        <h5>Síguenos</h5>
        <ul class="social list-inline">
          <li class="list-inline-item"><a href="{{conf?.fac}}" target="_blank" rel="noopener" aria-label="Facebook"><i
                class="fab fa-facebook fa-lg"></i></a></li>
          <li class="list-inline-item"><a href="https://twitter.com/tu_usuario" target="_blank" rel="noopener"
              aria-label="Twitter"><i class="fab fa-twitter fa-lg"></i></a></li>
          <li class="list-inline-item"><a href="{{conf?.ins}}" target="_blank" rel="noopener" aria-label="Instagram"><i
                class="fab fa-instagram fa-lg"></i></a></li>
          <li class="list-inline-item"><a href="{{conf?.tik}}" target="_blank" rel="noopener" aria-label="LinkedIn"><i
                class="fab fa-telegram fa-lg"></i></a></li>
          <li class="list-inline-item"><a href="mailto:{{conf?.emi}}?subject=Consulta desde el sitio"
              aria-label="Enviar correo"><i class="fas fa-envelope fa-lg"></i></a></li>
          <li class="list-inline-item"><a href="tel:{{conf?.tel}}" aria-label="Llamar por teléfono"><i
                class="fas fa-phone fa-lg"></i></a></li>
        </ul>
      </div>

    </div>

    <hr>

    <div class="text-center small">
      <p>© 2025 UturuncoStudio. Todos los derechos reservados.</p>
    </div>
  </div>
</footer>